/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_In_Reason_From_Order_CancelInputs */

const vi_pll_in_reason_from_order_cancel = /** @type {(inputs: Pll_In_Reason_From_Order_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn từ hủy đơn`)
};

/**

* @param {Pll_In_Reason_From_Order_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_in_reason_from_order_cancel = /** @type {((inputs?: Pll_In_Reason_From_Order_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_In_Reason_From_Order_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_in_reason_from_order_cancel(inputs)
});